import styled from 'styled-components';

export const EarningPlanStyled = styled.div<{
  $expired?: boolean;
  $active?: boolean;
}>`
  padding: 10px 16px;
  border: 1px solid
    ${({ $expired, $active, theme }) =>
      $expired ? theme.lightGray : $active ? theme.primary : 'none'};
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  margin-bottom: 16px;
  background-color: ${({ $expired, theme }) =>
    $expired ? 'none' : theme.white};

  box-shadow: ${({ $expired, theme }) =>
    $expired ? 'none' : theme.shadows.shadow1};
`;

export const Pill = styled.div<{ $expired?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  width: 70px;
  background-color: ${({ $expired, theme }) =>
    $expired ? theme.lightGray : theme.primary};
  border-radius: 20px;
`;
